var Mutations;
(function (Mutations) {
    Mutations["SET_FINANCE_BREADCRUMB"] = "setFinanceBreadcrumb";
})(Mutations || (Mutations = {}));
export { Mutations };
